import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { CommonService } from "./common.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private router: Router, private commonService: CommonService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        var token = ""
        token = localStorage.getItem("token")!;
        if (token !== '' && !req.url.includes("api/configuration")
            && !req.url.includes("p4w/security")
            && !req.url.includes("api/users/auth-user")
            && !req.url.includes('api/users/actionstep-auth-user')) {
            token = this.commonService.decrypt(token);
            const tokenValue = 'Bearer ' + token;
            req = req.clone({
                setHeaders: {
                    "Authorization": tokenValue
                }
            });
        }
        return next.handle(req).pipe(tap((event: HttpEvent<any>) => {

        }));

    }
}
